import React, { Component } from "react"
import {
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
  List,
} from "react-virtualized"
import AssetItemCard from "../AssetItemCard"
import PropTypes from "prop-types"

class SearchResultsVirtualized extends Component {
  constructor(props) {
    super(props)

    this.cache = new CellMeasurerCache({
      minHeight: 160,
      fixedWidth: true,
    })
  }

  componentDidMount() {
    window.addEventListener("resize", this.recomputeRows)
  }

  componentDidUpdate() {
    this.scrollToTop()
  }

  recomputeRows = () => {
    this.cache.clearAll()
    /* istanbul ignore next */
    if (this.list) {
      this.list.recomputeRowHeights()
    }
  }

  scrollToTop = () => {
    /* istanbul ignore next */
    if (this.list) {
      this.list.scrollToRow(0)
    }
  }

  render() {
    const results = this.props.results

    return (
      <AutoSizer>
        {({ width, height }) => (
          <List
            ref={list => {
              this.list = list
            }}
            width={
              /* istanbul ignore next */ process.env.NODE_ENV === "test"
                ? 1000
                : width
            }
            height={
              /* istanbul ignore next */ process.env.NODE_ENV === "test"
                ? 1000
                : height
            }
            rowCount={results.length}
            rowHeight={this.cache.rowHeight}
            noRowsRenderer={() => (
              <div className="no-results">
                <p>No results found. Try a new search.</p>
              </div>
            )}
            rowRenderer={({ index, key, parent, style }) => (
              <CellMeasurer
                cache={this.cache}
                key={key}
                parent={parent}
                rowIndex={index}
                columnIndex={0}
              >
                {({ measure }) => (
                  <AssetItemCard
                    key={key}
                    {...results[index]}
                    style={style}
                    deviceType={this.props.deviceType}
                  />
                )}
              </CellMeasurer>
            )}
          />
        )}
      </AutoSizer>
    )
  }
}

SearchResultsVirtualized.propTypes = {
  results: PropTypes.arrayOf(
    PropTypes.shape({ item: PropTypes.shape(AssetItemCard.propTypes) })
  ),
  deviceType: PropTypes.string.isRequired,
}

export default SearchResultsVirtualized
